import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import CelltrionCare from "../popup/celltrionCare";
import { Link } from 'react-router-dom';
import entryImage from '../../assets/img/vegzelma_entry2.png';

export const VegzelmaEntry = () => {
      const [modalShow, setModalShow] = useState(false);

    return (
        <><section className='entry vegzelma-entry' style={{ backgroundImage: `url(${entryImage})`, backgroundPosition: 'right' }}>
            <Container>
                <div className='entry-text'>

                    <Link to="/inquiry-form/vegzelma" className='theme-btn'>Enroll in Co-pay Program</Link>
                    <p className='text-1'>Commercially insured patients taking VEGZELMA<sup className="reg">&reg;</sup> may be able to receive assistance through the Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance Program</p>
                    <h5>If eligible, patients may pay as little as $0 for VEGZELMA<sup className="reg">&reg;</sup>.</h5>
                    <p className='text-2'>Celltrion CARES<sup className="reg">&reg;</sup> provides assistance` to help with patients’ out-of-pocket costs for VEGZELMA.</p>
                    <p className='text-3'>In order to be eligible for Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance, patients:</p>
                    <ul>
                        <li>
                            Must have commercial insurance
                        </li>
                        <li>Must not have Medicare, Medicaid, or other government insurance</li>
                        <li>Must meet certain guidelines set forth in the  <a
                            href="#"
                            onClick={() => setModalShow(true)}
                            style={{
                                color: "#000000",
                                textDecoration: "underline",
                            }}
                        >Terms and Conditions</a>&nbsp; for the Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance Program
                        </li>
                    </ul>
                    <p className='text-3'>
                        If you have any questions about the
                        Celltrion CARES<sup>&reg;</sup> Co-pay Assistance
                        Program for VEGZELMA<sup className="reg">&reg;</sup> or
                        pharmacy assistance, please call <strong>1.877.812.6662 Monday-Friday, 8 AM-8 PM ET.</strong>
                    </p>
                    <div className='entry-info-box'>
                        <p><strong>Instructions for medical claims</strong></p>
                        <ul>
                            <li>The VEGZELMA co-pay card can be used for both pharmacy and medical claims. For medical claims, fax a copy of the UB-04 form or the CMS-1500 form and the Explanation of Benefits (EOB) to 1-877-431-6444.</li>
                        </ul>
                    </div>
                </div>
            </Container>
        </section><CelltrionCare
                show={modalShow}
                onHide={() => setModalShow(false)}
                isVegzelma={true}
                isZymfentra={false}
                isYuflyma={false}
                isAdalimumab={false}
                isSteqeyma={false} /></> 
    )
}
